import { render, staticRenderFns } from "./AllocationResources.vue?vue&type=template&id=25067d46"
import script from "./AllocationResources.vue?vue&type=script&lang=js"
export * from "./AllocationResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25067d46')) {
      api.createRecord('25067d46', component.options)
    } else {
      api.reload('25067d46', component.options)
    }
    module.hot.accept("./AllocationResources.vue?vue&type=template&id=25067d46", function () {
      api.rerender('25067d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/AllocationResources.vue"
export default component.exports